var PENDING = "Lead Pending";
var PROCESSING = "RM on Processing";

export { PENDING, PROCESSING };
